var _g, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProductImageDefault(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 171,
    height: 174,
    viewBox: "0 0 171 174",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_136_392)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.5879,
    y: 18.7466,
    width: 121.785,
    height: 125.233,
    rx: 12,
    fill: "#E6E6E6"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_136_392)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98.6174 60.5366H72.3439C65.7965 60.5366 60.4888 65.8443 60.4888 72.3917V90.3346C60.4888 96.882 65.7965 102.19 72.3439 102.19H98.6174C105.165 102.19 110.473 96.882 110.473 90.3346V72.3917C110.473 65.8443 105.165 60.5366 98.6174 60.5366Z",
    stroke: "#B0B0B0",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeDasharray: "7 5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.4907 91.9242L79.5279 83.3589L84.6204 87.063L93.6485 78.9604L102.908 91.9235",
    stroke: "#B0B0B0",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.2369 79.2638C85.308 79.2638 86.9869 77.5848 86.9869 75.5137C86.9869 73.4426 85.308 71.7637 83.2369 71.7637C81.1658 71.7637 79.4868 73.4426 79.4868 75.5137C79.4868 77.5848 81.1658 79.2638 83.2369 79.2638Z",
    stroke: "#B0B0B0",
    strokeWidth: 3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_136_392",
    x: 0.587891,
    y: 0.746582,
    width: 169.785,
    height: 173.233,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.811849 0 0 0 0 0.765269 0 0 0 0 0.674849 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_136_392"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_136_392",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_136_392"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 51.9062,
    height: 43.5756,
    fill: "white",
    transform: "translate(59.5273 59.5752)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductImageDefault);
export default __webpack_public_path__ + "static/media/product-image-default.922c3704dcf4099e7cf3c5914b490e8f.svg";
export { ForwardRef as ReactComponent };